module.exports = __webpack_public_path__ + "media/images/arrows/cyan-right-1afccc1ed4237919299a441d5d443593.svg";